import * as CryptoJS from 'crypto-js';
import * as i0 from "@angular/core";
export class AesService {
    constructor() {
        this.secretKey = 'FITCONS1FITCONS2'; // 16 karakterlik key
        this.iv = 'FITCONS3FITCONS4'; // 16 karakterlik IV
    }
    // AES ile şifreleme (Encrypt)
    encrypt(text) {
        try {
            const key = CryptoJS.enc.Utf8.parse(this.secretKey);
            const iv = CryptoJS.enc.Utf8.parse(this.iv);
            const encrypted = CryptoJS.AES.encrypt(text, key, {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });
            return encrypted.toString();
        }
        catch (error) {
            return '';
        }
    }
    // AES ile şifre çözme (Decrypt)
    decrypt(encryptedText) {
        try {
            const key = CryptoJS.enc.Utf8.parse(this.secretKey);
            const iv = CryptoJS.enc.Utf8.parse(this.iv);
            const decrypted = CryptoJS.AES.decrypt(encryptedText, key, {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });
            return decrypted.toString(CryptoJS.enc.Utf8);
        }
        catch (error) {
            return '';
        }
    }
}
AesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AesService_Factory() { return new AesService(); }, token: AesService, providedIn: "root" });
